import { render, staticRenderFns } from "./TempBasedPr.vue?vue&type=template&id=344e8c78"
import script from "./TempBasedPr.vue?vue&type=script&lang=js"
export * from "./TempBasedPr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports